import { render, staticRenderFns } from "./GeofenceDetails.vue?vue&type=template&id=4ed4f534&scoped=true&lang=pug"
import script from "./GeofenceDetails.vue?vue&type=script&lang=js"
export * from "./GeofenceDetails.vue?vue&type=script&lang=js"
import style0 from "./GeofenceDetails.vue?vue&type=style&index=0&id=4ed4f534&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed4f534",
  null
  
)

export default component.exports